module.exports = {
    committee_id: 512,
    source: 2,
    key: 'Medcon20201010@)@)@!)',
    mini_url: 'https://www.sciconf.cn/'
}